import React, { FunctionComponent, type JSX } from 'react';

import './PayacaPhoneLink.sass';

import UntitledIcon from '@payaca/untitled-icons';

type Props = {
  showPhoneIcon?: boolean;
  anchorContent?: React.ReactNode;
};

const PayacaPhoneLink: FunctionComponent<Props> = ({
  showPhoneIcon = false,
  anchorContent,
}: Props): JSX.Element => {
  return (
    <a
      className="payaca-phone-link"
      href="tel:+443330509475"
      title="0333 050 9475"
    >
      {showPhoneIcon && <UntitledIcon name="phone.3" />}
      {anchorContent ? anchorContent : <span>0333 050 9475</span>}
    </a>
  );
};

export default PayacaPhoneLink;
